import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { UserSecretsCreateInput } from '@libs/types/src/user/input-type/user/user-secrets.create-input';
import { Injectable } from '@angular/core';
import { OkObject } from '@it2go/types';
import { UserSecretsInput } from '@libs/types/src/user/input-type/user/user-secrets.input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { GridInput } from '@it2go/data-grid';
import { userSecretsItemFrag } from './types/user.types';
import { filterFrag } from './types/filter.types';
import { UserSecretsGridObject } from '@libs/types/src/user/object-type/user-secrets-grid.object';

@Injectable({ providedIn: 'root' })
export class UserSecretsGqlService extends GqlServiceV2 {

    public createUserSecret(input: UserSecretsCreateInput): Promise<OkObject> {
        return this.mutate(
            `
                mutation($input: UserSecretsCreateInput!) {
                    userSecrets {
                        create(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getUserSecrets(input: GridInput, frag: string = userSecretsItemFrag) {
        return this.query<UserSecretsGridObject>(
            `
                query($input: GridInput!) {
                    userSecrets {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public hasUserSecret(input: UserSecretsInput): Promise<OkObject> {
        return this.query(
            `
                query($input: UserSecretsInput!) {
                    userSecrets {
                        hasSecret(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteUserSecret(input: IdInput): Promise<OkObject> {
        return this.mutate(
            `
                mutation($input: IdInput!) {
                    userSecrets {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
